import React from 'react';

import AppleIcon from '@ott/icon-apple';
import GoogleIcon from '@ott/icon-google';
import MailruIcon from '@ott/icon-mailru';
import OdnoklassnikiIcon from '@ott/icon-odnoklassniki';
import TwitterIcon from '@ott/icon-twitter-new';
import VkontakteIcon from '@ott/icon-vkontakte';
import { lang } from '@ott/l10n';

import SocialItem from './blocks/SocialItem';
import { APPLE, GOOGLE, MAILRU, ODNOKLASSNIKI, TWITTER, VKONTAKTE } from './constants';

import styles from './Social.scss';

const isRuLocale = lang === 'ru';

const DEFAULT_SOCIALS = [
  {
    name: TWITTER,
    icon: <TwitterIcon className={styles.icon} />,
  },
  {
    name: GOOGLE,
    icon: <GoogleIcon className={styles.icon} />,
  },
  {
    name: APPLE,
    icon: <AppleIcon className={styles.icon} />,
  },
];

const RU_LOCALE_SOCIALS = [
  {
    name: VKONTAKTE,
    icon: <VkontakteIcon className={styles.icon} />,
  },
  {
    name: ODNOKLASSNIKI,
    icon: <OdnoklassnikiIcon className={styles.icon} />,
  },
  {
    name: MAILRU,
    icon: <MailruIcon className={styles.icon} />,
  },
  {
    name: TWITTER,
    icon: <TwitterIcon className={styles.icon} />,
  },
  {
    name: GOOGLE,
    icon: <GoogleIcon className={styles.icon} />,
  },
  {
    name: APPLE,
    icon: <AppleIcon className={styles.icon} />,
  },
];

const SOCIALS = isRuLocale ? RU_LOCALE_SOCIALS : DEFAULT_SOCIALS;

const Social = () => (
  <div className={styles.container}>
    <div className={styles.list}>
      {SOCIALS.map((social) => {
        return (
          <SocialItem
            key={social.name}
            name={social.name}
            icon={social.icon}
            dataLocator={`social-icon-${social.name}`}
          />
        );
      })}
    </div>
  </div>
);

Social.propTypes = {};

export default Social;
